<template>
  <div class="full-calendar-header">
    <div class="header-left">
      <slot name="header-left"></slot>
    </div>
    <div class="header-center">
      <span class="prev-month" @click.stop="goPrevYear"><<</span>
      <span class="prev-month" @click.stop="goPrev"><</span>
      <span class="title">{{title}}</span>
      <span class="next-month" @click.stop="goNext">></span>
      <span class="next-month" @click.stop="goNextYear">>></span>
    </div>
    <div class="header-right">
      <span class="next-month" @click.stop="goToday">回到今天</span>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';

  export default {
    props : {
      currentMonth : {},
      titleFormat  : {},
      firstDay     : {},
      monthNames   : {},
      locale       : {}
    },
    data () {
      return {}
    },
    computed: {
      title () {
        if (!this.currentMonth) return;
        return this.currentMonth.locale(this.locale).format('YYYY年MM月')
      }
    },
    methods : {
      // 上一年
      goPrevYear () {
        const newMonth = moment(this.currentMonth).subtract(1, 'years').startOf('month');
        this.$emit('change', newMonth);
      },

      // 上个月
      goPrev () {
        const newMonth = moment(this.currentMonth).subtract(1, 'months').startOf('month');
        this.$emit('change', newMonth);
      },

      // 下个月
      goNext () {
        const newMonth = moment(this.currentMonth).add(1, 'months').startOf('month');
        this.$emit('change', newMonth);
      },

      // 下一年
      goNextYear () {
        const newMonth = moment(this.currentMonth).add(1, 'years').startOf('month');
        this.$emit('change', newMonth);
      },

      // 去当前月
      goToday() {
        const newMonth = moment(new Date())
        this.$emit('change', newMonth);
      },
    }
  }
</script>
<style lang="scss">
.full-calendar-header{
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 10px 0;
  .header-left,.header-right{
    flex:1;
  }
  .header-right {
    text-align: right;
  }
  .header-center{
    flex:3;
    text-align:center;
    .title{
      margin: 0 10px;
    }
  }
  .prev-month,
  .next-month{
    padding: 0 10px;
    cursor: pointer;
    color: #19aa8d;
    &:hover {
      opacity: .7;
    }
  }
}
</style>
